import React from 'react';

// Add this CSS to your global stylesheet or use styled-components/emotion
const sliderStyles = `
/* The track */
input[type="range"] {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 8px; /* Slightly taller track for better centering */
  background: #374151; /* gray-700 */
  border-radius: 9999px;
  outline: none;
  padding: 0;
  margin: 10px 0;
  position: relative; /* Add position relative */
}

/* The thumb/handle */
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #3B82F6; /* primary blue */
  cursor: pointer;
  transition: background 0.15s ease-in-out;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  margin-top: -6px; /* Center vertically on the track: (thumb height - track height) / -2 */
}

input[type="range"]::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border: 0;
  border-radius: 50%;
  background: #3B82F6; /* primary blue */
  cursor: pointer;
  transition: background 0.15s ease-in-out;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

/* Firefox specific track styling to center thumb */
input[type="range"]::-moz-range-track {
  height: 8px;
  background: #374151;
  border-radius: 9999px;
}

/* Hover state */
input[type="range"]::-webkit-slider-thumb:hover {
  background: #60A5FA; /* primary-light blue */
}

input[type="range"]::-moz-range-thumb:hover {
  background: #60A5FA; /* primary-light blue */
}

/* Focus state */
input[type="range"]:focus {
  outline: none;
}

input[type="range"]:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5);
}

input[type="range"]:focus::-moz-range-thumb {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.5);
}
`;

const SimpleSlider = ({ min, max, step, value, onChange, label, unit }) => {
  return (
    <div className="mb-6">
      <style>{sliderStyles}</style>
      
      <div className="flex justify-between items-center mb-2">
        <label className="text-gray-300 text-sm">{label}</label>
        <span className="text-gray-300 font-medium">{value} {unit}</span>
      </div>
      
      <input 
        type="range" 
        min={min} 
        max={max} 
        step={step} 
        value={value}
        onChange={onChange}
      />
      
      <div className="flex justify-between text-xs text-gray-500 mt-1">
        <span>{min} {unit}</span>
        <span>{max} {unit}</span>
      </div>
    </div>
  );
};

export default SimpleSlider;